module.exports = __webpack_public_path__ + "img/ContratoHNNacional2.61783abf.png";